export default function Footer () {
  return (
    <footer className="footer">
      <img src={require('../assets/EZBenefitslogotagline.jpg')} alt="logo" className="footer-logo" />
    </footer>
  );
};

